import { useState, useEffect } from 'react';
import type {
  WCardSuiteSearchView,
  WCardSuiteSummaryView,
  WCardSuiteSearchRequest,
} from '@zola/svc-web-api-ts-client';
import fetchCardCatalogFacetedSearch from 'cards/components/common/SingleSample/util/api/fetchCardCatalogFacetedSearch';
import { CardSuiteInfoSummary } from '../types';
import { mapCardSuiteToCardInfoSummary } from '../mappers';

const useMostPopularSamplesFromFamily = (
  familyName?: string,
  sampleCardType?: string,
  cardSuiteFilterFn?: (suites: WCardSuiteSummaryView[]) => WCardSuiteSummaryView
): CardSuiteInfoSummary | undefined => {
  const [cardInfo, setCardInfo] = useState<CardSuiteInfoSummary | undefined>();

  useEffect(() => {
    if (familyName) {
      const req: WCardSuiteSearchRequest = {
        offset: 0,
        limit: 12,
        active_only: true,
        has_custom_photo: undefined,
        family: familyName,
        lead_card_type: (sampleCardType as unknown) as WCardSuiteSearchRequest.LeadCardTypeEnum,
        single_sample_available: true,
      };

      fetchCardCatalogFacetedSearch(req)
        .then((res: WCardSuiteSearchView) => {
          const { suites } = res;
          // Default chosen is first/highest ranked
          let chosenSuite: WCardSuiteSummaryView = suites?.[0] || {};
          if (suites && suites.length > 0 && cardSuiteFilterFn) {
            chosenSuite = cardSuiteFilterFn(suites);
          }
          const newCardInfo = mapCardSuiteToCardInfoSummary(chosenSuite);

          setCardInfo(newCardInfo);
        })
        .catch(e => {
          throw new Error(e);
        });
    }
  }, [cardSuiteFilterFn, familyName, sampleCardType]);

  return cardInfo;
};

export default useMostPopularSamplesFromFamily;
